<template>
  <footer class="py-3 footer bottom-0 fix_footer_bottom w-100 blur ">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
          <div class="mb-4 col-lg-12 mb-lg-0">
              <div class="text-sm text-right copyright text-muted"
                   :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'">
                 نسخه {{ $store.state.appVersion }}
              </div>
              <div v-if="1 == 2" class="text-sm text-right copyright text-muted"
                   :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'">
                  ©
                  {{ new Date().getFullYear() }}, تمامی حقوق مادی و معنوی محصول
                  متعلق به
                  <a href="#"
                     class="font-weight-bold"
                     target="_blank">{{ $store.state.company_title }} </a>
                  می باشد. نسخه {{ $store.state.appVersion }}
              </div>
          </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
